import { format } from 'date-fns';

export const indexPageSlug = 'index'

export const site = {
  name: 'scmg.org',
  hostname: 'www.scmg.org',
  title: 'Sharp Community Medical Group',
  description:
    "Sharp HealthCare is San Diego's health care leader with hospitals in San Diego, affiliated medical groups, urgent care centers and a health plan. Sharp provides medical services in virtually all fields of medicine, including primary care, heart care, cancer treatment, orthopedics and women’s health. Looking for San Diego doctors? Seeking nursing jobs in San Diego? Visit Sharp.com or call 1-800-82-SHARP.",
  url: 'https://www.scmg.org',
}

export const twitter = {
  site: '@sharphealthcare',
}

// The first key is the content type for the page and the second is the path for these content types
export const contentTypeBasePathMap: Record<string, string> = {
  newsArticle: '/health-news/',
  news2knowArticle: '/providers/news2know/',
  providerPage: '/providers/',
  page: '/',
  person: '/',
  provider: '/doctors/',
  'contact-us': '/contact-us/',
  termsOfUse: '/terms-of-use/',
  patientResources: '/patient-resources/',
  locations: '/locations/',
  findADoctor: '/find-a-doctor***',
  caseManagement: '/case-management/',
  vaccinations: '/vaccinations/',
  aboutUs: '/about-us/',
  prospectivePhysicians: '/prospective-physicians/',
}

export const blockQueryParamMap: Record<string, string> = {
  campaignCardImageLongBlock: 'campaign-card-image-long-page',
  healthNewsStoriesBlock: 'health-news-stories-page',
  providerNewsBlock: 'provider-news-page',
}

export const searchInputDebounceMs = 300
export const searchMinimumQueryLength = 3

  /**
   * Formats a date string into a localized date string.
   *
   * @param {string} dateStr - The date string to format.
   * @returns {string} The formatted date string, or an empty string if the input is not a valid date.
   */
// format date to mm/dd/yyyy
export const DATE_FORMAT_OPTIONS = { month: '2-digit', day: '2-digit', year: 'numeric' };

export const formatDate = (dateStr: string) => {
  const date = new Date(dateStr);
  return isNaN(date) ? "" : date.toLocaleDateString(undefined, DATE_FORMAT_OPTIONS);
};

export const formatTime = (dateStr: string) => {
  const date = new Date(dateStr);
  return isNaN(date) ? "" : date.toLocaleDateString(undefined, { hour: '2-digit', minute: '2-digit'});
};

// format date to January 1, 2025
export const formatDateString = (dateString: string) => {
  const date = new Date(dateString);
  return format(date, 'MMMM dd, yyyy');
};

// format date to mm/dd/yyyy from seconds
export const formatDateFromSeconds = (timestamp: number) => {
  const date = new Date(timestamp.toString().length === 10 ? timestamp * 1000 : timestamp);

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
}

// all regions
export const regionNames = ["Metro", "Inland North", "Grossmont", "Coronado", "Chula Vista"];

// total number of items to display on page for pagination
export const itemsPerPage = 10

export const rolesMap = {
  'Administrator': 'Administrators',
  'Network Management Staff': 'Network management staff',
  'Senior Staff': 'Senior staff',
  'General Employee': 'General employees',
  'Office Manager': 'Office managers',
  'Office Staff': 'Office staff',
  'Practice Management Staff': 'Practice management staff',
  'Advanced Practice Clinician': 'Advanced practice clinicians',
  'Physician': 'Physicians',
  'Super Specialist': 'Super specialists',
  'Specialist': 'Specialists',
  'Primary Care': 'Primary care physicians'
}

export const providerTypes = [
  { id: 1, name: "Primary Care" },
  { id: 2, name: "Specialist" },
  { id: 3, name: "Super-Specialist" },
];